import { IconInfoSquareRounded } from '@calendly/ui/components/glyphs/IconInfoSquareRounded';
import { GridItem } from '@calendly/ui/components/grid';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { usePresetFilterSheetLayout } from '../preset_filter_sheet_layout_context';
import { presetFilterFieldContentCss, presetFilterFieldItemCss, presetFilterFieldLabelCss, presetFilterCheckboxContainerCss, presetFilterLabelContainerCss } from '../preset_filter_sheet_styles';
import { LeftColumn } from './left_column';
import { CheckboxContainer, CheckboxLeftColumnWrapper, CheckboxRightColumnWrapper, LabelContainer, RightColumnWrapper } from './styles';
const columnLabelContainer = "c1gq7o2d";
const columnGridItemCss = "c68057r";
const RowFilterLayout = ({
  label,
  tooltip,
  children
}) => <>
    <LeftColumn>
      <LabelContainer>
        <BodyText weight="bold">
          {label}
        </BodyText>
        {tooltip && <ProTip>{tooltip}</ProTip>}
      </LabelContainer>
    </LeftColumn>
    <RightColumnWrapper>
      {children}
    </RightColumnWrapper>
  </>;
const ColumnFilterLayout = ({
  label,
  tooltip,
  children
}) => {
  const presetSheet = usePresetFilterSheetLayout();
  const fieldLabel = presetSheet ? <LabelText size="large" weight="bold">
      {label}
    </LabelText> : <BodyText weight="bold">
      {label}
    </BodyText>;
  const fieldBody = <>
      <LabelContainer className={classNames(presetSheet ? presetFilterFieldLabelCss : columnLabelContainer, presetSheet && presetFilterLabelContainerCss)}>
        {fieldLabel}
        {tooltip && (presetSheet ?
      // Figma Tracking IDs: rounded-square info glyph @ 16px → ProTip size="small".
      <ProTip size="small" glyphIcon={IconInfoSquareRounded}>
              {tooltip}
            </ProTip> : <ProTip>{tooltip}</ProTip>)}
      </LabelContainer>
      {children}
    </>;
  return <GridItem size="12" className={classNames({
    [columnGridItemCss]: !presetSheet,
    [presetFilterFieldItemCss]: presetSheet
  })}>
      {presetSheet ? <div className={presetFilterFieldContentCss}>{fieldBody}</div> : fieldBody}
    </GridItem>;
};
export const FilterLayout = ({
  label,
  tooltip,
  children,
  useColumnLayout
}) => {
  const Layout = useColumnLayout ? ColumnFilterLayout : RowFilterLayout;
  return <Layout label={label} tooltip={tooltip}>{children}</Layout>;
};

// Checkbox-specific layouts
const RowCheckboxFilterLayout = ({
  label,
  children
}) => <>
    <CheckboxLeftColumnWrapper>
      <LabelContainer>
        <BodyText weight="bold">
          {label}
        </BodyText>
      </LabelContainer>
    </CheckboxLeftColumnWrapper>
    <CheckboxRightColumnWrapper>
      <CheckboxContainer>
        {children}
      </CheckboxContainer>
    </CheckboxRightColumnWrapper>
  </>;
const ColumnCheckboxFilterLayout = ({
  label,
  children
}) => {
  const presetSheet = usePresetFilterSheetLayout();
  const checkboxBody = <>
      <LabelContainer className={classNames(presetSheet ? presetFilterFieldLabelCss : columnLabelContainer, presetSheet && presetFilterLabelContainerCss)}>
        {presetSheet ? <LabelText size="large" weight="bold">
            {label}
          </LabelText> : <BodyText weight="bold">
            {label}
          </BodyText>}
      </LabelContainer>
      <CheckboxContainer fieldColumn className={presetSheet ? presetFilterCheckboxContainerCss : undefined}>
        {children}
      </CheckboxContainer>
    </>;
  return <GridItem size="12" className={classNames({
    [columnGridItemCss]: !presetSheet,
    [presetFilterFieldItemCss]: presetSheet
  })}>
      {presetSheet ? <div className={presetFilterFieldContentCss}>{checkboxBody}</div> : checkboxBody}
    </GridItem>;
};
export const CheckboxFilterLayout = ({
  label,
  children,
  useColumnLayout
}) => {
  const Layout = useColumnLayout ? ColumnCheckboxFilterLayout : RowCheckboxFilterLayout;
  return <Layout label={label}>{children}</Layout>;
};

require("./filter_layout.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_layout.js");